import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "page-header",
  class: "grid grid-cols-12 items-center justify-center lg:justify-between gap-5 mt-5 py-5 px-2"
}
const _hoisted_2 = { class: "text-center md:text-start text-2xl font-bold col-span-8 flex items-center" }
const _hoisted_3 = { class: "flex items-center gap-3 col-span-12 lg:col-span-4" }
const _hoisted_4 = { class: "p-input-icon-right w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-2 py-5 font-bold"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("Filtros aplicados:"), -1)
const _hoisted_8 = {
  key: 3,
  class: "my-12 grid gap-y-8 px-2"
}
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" }
const _hoisted_10 = { class: "relative rounded-t-lg overflow-hidden" }
const _hoisted_11 = {
  key: 0,
  id: "tag-status",
  class: "absolute top-3 right-3 px-2 py-1 text-sm rounded-full font-bold shadow-md flex items-center gap-2 bg-green-500 text-green-100 z-40"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString("Concluído"), -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex justify-between items-center" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "bg-h-primary-700 px-2 rounded-xl" }
const _hoisted_18 = { class: "text-[10px] text-h-primary-50 truncate" }
const _hoisted_19 = {
  key: 0,
  class: "text-gray-400 absolute truncate max-w-[300px]"
}
const _hoisted_20 = { class: "flex flex-wrap justify-end gap-3 -mt-5" }
const _hoisted_21 = { class: "ml-1" }
const _hoisted_22 = {
  key: 4,
  class: "flex justify-center items-center mb-10"
}
const _hoisted_23 = {
  id: "classroom-input",
  class: "font-bold"
}
const _hoisted_24 = { for: "classroom" }
const _hoisted_25 = {
  id: "status-input",
  class: "font-bold"
}
const _hoisted_26 = { for: "status" }
const _hoisted_27 = {
  id: "buttons",
  class: "flex justify-end gap-3 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Todos os cursos", en: "All courses" })), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.params.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.name) = $event)),
            placeholder: _ctx.$t('course.search'),
            class: "p-inputtext-sm",
            onKeyup: _ctx.onFilter,
            removable: ""
          }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
          _hoisted_5
        ]),
        _createVNode(_component_Button, {
          icon: "pi pi-filter",
          class: "btn-primary p-button-sm scale-90 w-[140px]",
          label: "Filtros",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.dialogFilter = true), ["prevent"]))
        })
      ])
    ]),
    (
        _ctx.filters?.name ||
        _ctx.filters?.done ||
        _ctx.filters?.done === false ||
        _ctx.filters?.classroomName
      )
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _hoisted_7,
          (_ctx.filters?.name)
            ? (_openBlock(), _createBlock(_component_Chip, {
                key: 0,
                label: _ctx.filters.name,
                onRemove: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRemoveFilter('name'))),
                removable: ""
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.filters?.done || _ctx.filters?.done === false)
            ? (_openBlock(), _createBlock(_component_Chip, {
                key: 1,
                label: `${
          _ctx.filters.done ? _ctx.courseOptions[0].name : _ctx.courseOptions[1].name
        }`,
                onRemove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRemoveFilter('done'))),
                removable: ""
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.filters?.classroomName)
            ? (_openBlock(), _createBlock(_component_Chip, {
                key: 2,
                label: `Turma: ${_ctx.filters.classroomName}`,
                onRemove: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onRemoveFilter('classroom'))),
                removable: ""
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loader)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          loader: _ctx.loader
        }, null, 8, ["loader"]))
      : (_ctx.courses?.length === 0)
        ? (_openBlock(), _createBlock(_component_EmptyData, {
            key: 2,
            data: _ctx.courses?.length === 0,
            label: _ctx.emptyState.description,
            image: _ctx.emptyState.image,
            imgSize: "h-40 md:h-64 mt-20"
          }, null, 8, ["data", "label", "image"]))
        : (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, i) => {
                return _withDirectives((_openBlock(), _createBlock(_component_Card, {
                  initial: _ctx.initialMotion,
                  enter: _ctx.enterMotion.getEnterMotion((i + 1) * 100),
                  class: "group bg-white !rounded-2xl !shadow-md hover:!shadow-xl transition-all duration-200 overflow-hidden cursor-default",
                  key: i
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      (course?.done)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        src: course?.file?.url || _ctx.emptyImg,
                        onError: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
                        class: "w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-200",
                        loading: "lazy"
                      }, null, 40, _hoisted_14)
                    ])
                  ]),
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h5", {
                        class: "truncate max-w-fit",
                        title: course.name
                      }, _toDisplayString(course.name), 9, _hoisted_16),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.generics.getDurationTime(Number(course.duration))), 1)
                      ])
                    ]),
                    (course?.classroom)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString("Turma: " + course?.classroom?.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_Button, {
                        class: "btn-primary w-full lg:w-fit p-button-sm flex gap-2 items-center justify-center",
                        onClick: ($event: any) => (_ctx.goToCourse(course))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { name: "md-playcirclefilled-twotone" }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Acessar curso",
                      en: "Access course",
                    })), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (course.done && course?.hasCertificate)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "btn-outline w-full lg:w-fit p-button-sm flex justify-center content-center",
                            loading: _ctx.loaderCert[i]?.value,
                            onClick: ($event: any) => (_ctx.getCertificate(course, i))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.loaderCert[i]?.value)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    name: "md-changecircle-round",
                                    class: _normalizeClass(['animate-spin'])
                                  }))
                                : (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    name: "md-filedownload-round"
                                  })),
                              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Certificado",
                      en: "Certificate",
                    })), 1)
                            ]),
                            _: 2
                          }, 1032, ["loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["initial", "enter"])), [
                  [_directive_motion]
                ])
              }), 128))
            ])
          ])),
    (_ctx.params.total > _ctx.params?.size)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_component_Paginator, {
            rows: _ctx.params?.size,
            totalRecords: _ctx.params?.total,
            onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.paginate($event)))
          }, null, 8, ["rows", "totalRecords"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogFilter,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogFilter) = $event)),
      header: "Selecione os filtros",
      style: { width: '25vw' },
      breakpoints: { '1199px': '75vw', '575px': '90vw' },
      draggable: false,
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFilter && _ctx.onFilter(...args)), ["prevent"])),
          class: "flex flex-col gap-5"
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("homeStudent.filters.classroom.title")), 1),
            _createVNode(_component_AutoComplete, {
              id: "classroom",
              modelValue: _ctx.params.classroomName,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.params.classroomName) = $event)),
              suggestions: _ctx.classrooms,
              forceSelection: true,
              onComplete: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getClasses($event))),
              placeholder: _ctx.$t('homeStudent.filters.classroom.placeholder'),
              optionLabel: "name",
              class: _normalizeClass(`w-full mt-2`)
            }, null, 8, ["modelValue", "suggestions", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("homeStudent.filters.status.title")), 1),
            _createVNode(_component_Dropdown, {
              id: "status",
              modelValue: _ctx.params.done,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.params.done) = $event)),
              optionLabel: "name",
              optionValue: "code",
              placeholder: _ctx.$t('homeStudent.filters.status.placeholder'),
              class: _normalizeClass(`dropdown w-full mt-2`),
              options: _ctx.courseOptions
            }, null, 8, ["modelValue", "placeholder", "options"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Button, {
              label: _ctx.$t('labels.cancel'),
              class: "btn-outline",
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.dialogFilter = false), ["prevent"]))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              type: "submit",
              label: _ctx.$t('labels.apply'),
              disabled: 
              _ctx.params.done === undefined && _ctx.params.classroomName === undefined
            ,
              class: "btn-primary"
            }, null, 8, ["label", "disabled"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}